import { metrics } from '@atlassian/browser-metrics';

import { appWasServerSideRendered } from 'src/utils/ssr';

export {
  MetricSender,
  PageSegmentMetricStarter,
  useAbortMetricOnUnmount,
  startMetric,
} from './components/browser-metrics';

const PAGE_LOAD_SSR_CONFIG = appWasServerSideRendered()
  ? { doneAsFmp: true }
  : undefined;

// Metrics for full page load events
// These events will be prepended with "bitbucket.fe.page-load." in the Performance Portal
export const DASHBOARD_OVERVIEW_LOAD = metrics.pageLoad({
  key: 'workspace-overview',
  ssr: PAGE_LOAD_SSR_CONFIG,
});

export const PULL_REQUEST_LOAD = metrics.pageLoad({
  key: 'pull-request',
  ssr: PAGE_LOAD_SSR_CONFIG,
});

export const PULL_REQUEST_CREATE_LOAD = metrics.pageLoad({
  key: 'repository-create-pr',
  ssr: PAGE_LOAD_SSR_CONFIG,
});

export const PULL_REQUEST_LIST_LOAD = metrics.pageLoad({
  key: 'repository-pull-requests',
  ssr: PAGE_LOAD_SSR_CONFIG,
});

export const BRANCH_LIST_LOAD = metrics.pageLoad({
  key: 'repository-branches-list',
  ssr: PAGE_LOAD_SSR_CONFIG,
});

export const BRANCH_LOAD = metrics.pageLoad({
  key: 'repository-branch-detail',
  ssr: PAGE_LOAD_SSR_CONFIG,
});

export const SOURCE_FILE_LOAD = metrics.pageLoad({
  key: 'source.file',
  ssr: PAGE_LOAD_SSR_CONFIG,
});

export const SOURCE_DIRECTORY_LOAD = metrics.pageLoad({
  key: 'source.directory',
  ssr: PAGE_LOAD_SSR_CONFIG,
});

export const COMMIT_LIST_LOAD = metrics.pageLoad({
  key: 'repository-commits',
  ssr: PAGE_LOAD_SSR_CONFIG,
  featureFlags: ['commit-list-default-mainbranch'],
});

export const COMMIT_LOAD = metrics.pageLoad({
  key: 'repository-commit',
  ssr: PAGE_LOAD_SSR_CONFIG,
});

export const REPOSITORY_PACKAGES_LOAD = metrics.pageLoad({
  key: 'repository-packages',
  ssr: PAGE_LOAD_SSR_CONFIG,
});

export const WORKSPACE_REPOSITORIES_LIST_LOAD = metrics.pageLoad({
  key: 'workspace-repositories',
  ssr: PAGE_LOAD_SSR_CONFIG,
});

export const WORKSPACE_PROJECTS_LIST_LOAD = metrics.pageLoad({
  key: 'workspace-projects',
  ssr: PAGE_LOAD_SSR_CONFIG,
});

export const WORKSPACE_PULL_REQUESTS_LIST_LOAD = metrics.pageLoad({
  key: 'workspace-pull-requests',
  ssr: PAGE_LOAD_SSR_CONFIG,
});

// Metrics for page segment load events
// These events will be prepended with "bitbucket.fe.page-segment-load." in the Performance Portal
export const PR_DIFF_SEGMENT_LOAD = metrics.pageSegmentLoad({
  key: 'pull-request.diff',
});

// Metrics for interaction events
// These events will be prepended with "bitbucket.fe.inline-result." in the Performance Portal
export const PR_APPROVE_INTERACTION = metrics.interaction({
  key: 'pull-request.approve',
});

export const PR_MERGE_INTERACTION = metrics.interaction({
  key: 'pull-request.merge',
});

export const PR_CREATE_INTERACTION = metrics.interaction({
  key: 'pull-request.create',
});
